import Request from 'utilities/Request';
import {parseQuerystring} from 'utilities/URL';
import {mapDataType, FILTER_TYPE} from 'constants/FilterConstants';

const QUERY_KEY = 'pfilters';

export const fetchPageFiltersById = id =>
  Request.get(`/api/content/v1/pages/${id}/analyzer/load`);

export const savePageFilters = (id, filters) =>
  Request.post(`/api/content/v1/pages/${id}/analyzer`, {filters});

export const fetchFiltersFromQuerystring = () =>
  Promise.resolve().then(() => {
    const query = parseQuerystring();
    const param = query[QUERY_KEY];
    return JSON.parse(param);
  });

// Once the cards team runs a migration to
// update the saved filters in the database to change all filters of type
// 'LEGACY' to one of the new formats, then that section of the switch
// statement can be removed.  We still will need the parts that add the
// label though.
export const normalizeFilters = (filters, dataSources) =>
  filters.map(f => {
    const foundDS = dataSources.find(ds => f.dataSourceId === ds.id);

    switch (f.filterType) {
      case FILTER_TYPE.LEGACY: {
        if (!f.dataSourceId) {
          return {
            ...f,
            filterType: FILTER_TYPE.NAME,
            label: f.column,
          };
        }
        const foundCol = foundDS
          ? foundDS.columns.find(
              c => mapDataType(c.type) === f.dataType && c.name === f.column
            )
          : undefined;
        return {
          ...f,
          column: foundCol ? foundCol.id : f.column,
          label: f.column,
          filterType: FILTER_TYPE.COLUMN_ID,
        };
      }
      case FILTER_TYPE.NAME:
        return {...f, label: f.column};
      default: {
        const foundCol = foundDS
          ? foundDS.columns.find(c => c.id === f.column)
          : undefined;
        return {...f, label: foundCol ? foundCol.name : f.column};
      }
    }
  });
